import { FC } from "react";
import { MinusThickIcon, PlusThickIcon } from "src/assets/Icons";
import cn from "classnames";

type StepperProps = { value?: number; onChange?: (val: number) => void; min?: number; max?: number };

export const Stepper: FC<StepperProps> = ({ value = 0, onChange, min = 0, max = 99 }) => {
  const atMin = value <= min;
  const atMax = value >= max;

  return (
    <div className="flex items-center gap-3">
      <button
        type="button"
        disabled={atMin}
        className="border-font-active disabled:border-border-disabled flex size-8 items-center justify-center rounded-full border"
        onClick={() => onChange?.(Math.max(min, value - 1))}
      >
        <MinusThickIcon className={cn("size-3.5", atMin ? "text-icon-disabled" : "text-font-active")} />
      </button>
      <span className="text-font-default w-5 text-center text-base font-bold">{value}</span>
      <button
        type="button"
        disabled={atMax}
        className="border-font-active disabled:border-border-disabled flex size-8 items-center justify-center rounded-full border"
        onClick={() => onChange?.(Math.min(max, value + 1))}
      >
        <PlusThickIcon className={cn("size-3.5", atMax ? "text-icon-disabled" : "text-font-active")} />
      </button>
    </div>
  );
};
